import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core'
import {MoneyService} from '../../../core/forms/money.service'
import {I18nDirective} from '../../i18n/i18n.directive'

@Component({
  selector: 'cft-minimum-price-text',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [I18nDirective],
  template: `
    <ng-container *cftI18n="let t">
      {{ t('minimumPriceCard.fromPrice', {fromPrice: minimumPriceString()}) }}
    </ng-container>
  `,
})
export class MinimumPriceTextComponent {
  minimumPrice = input.required<number>()
  minimumPriceString = computed(() => `${MoneyService.rappenToChfAmount(this.minimumPrice())}`)
}
